/** Field paths that must always persist default/fallback values as strings. */
export const STRING_LITERAL_FIELD_PATHS = new Set(['profile_execution_id']);

function fieldPathKey(fieldPath) {
  if (!fieldPath || typeof fieldPath !== 'string') {
    return '';
  }

  const segments = fieldPath.split('.').filter(Boolean);

  return segments[segments.length - 1] || '';
}

function shouldKeepStringLiteral(value, fieldPath) {
  const key = fieldPathKey(fieldPath);

  if (key && STRING_LITERAL_FIELD_PATHS.has(key)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  const trimmed = value.trim();

  // Preserve zero-padded identifiers such as 00000000 or 01000000.
  return /^0\d+$/.test(trimmed);
}

export function coerceLiteral(value, fieldPath = '') {
  if (shouldKeepStringLiteral(value, fieldPath)) {
    if (typeof value === 'string') {
      return value.trim();
    }

    return String(value);
  }

  if (typeof value !== 'string') {
    return value;
  }

  const trimmed = value.trim();
  if (trimmed === 'true') {
    return true;
  }

  if (trimmed === 'false') {
    return false;
  }

  if (trimmed === 'null') {
    return null;
  }

  if (/^-?\d+(\.\d+)?$/.test(trimmed)) {
    return Number(trimmed);
  }

  if ((trimmed.startsWith('{') && trimmed.endsWith('}')) || (trimmed.startsWith('[') && trimmed.endsWith(']'))) {
    try {
      return JSON.parse(trimmed);
    } catch {
      return value;
    }
  }

  return value;
}
